export const setExternalSystems = "EXTERNAL_APIS/SET_SYSTEMS";
export const setApiCatalog = "EXTERNAL_APIS/SET_CATALOG";

export const externalSystems = "EXTERNAL_APIS/GET_SYSTEMS";
export const apiCatalog = "EXTERNAL_APIS/GET_CATALOG";
